
import { EN, EN_KO } from './helpers/GlobalsHelper';
import MediaHelper from './helpers/MediaHelper';
import RenderHelper from './helpers/RenderHelper';
import Cookies from 'js-cookie';

import $ from 'jquery';

// Import generic Modules.
import ClassClick from './modules/ClassClick';
import ImageSwap from './modules/ImageSwap';
import PageInfo from './modules/PageInfo';
import PhotoSwipe from './modules/PhotoSwipe';

// Import Sources.
import {initAccordions} from './source/Accordion';
import {initAddedToCart} from './source/AddedToCart';
import {initOpenBarcodeScanner} from './source/Barcode';
import {
	initAn150MomentsCarousel,
	initAn150ShopcatCarousel,
	initBrandCarousel,
	initContentCarousel,
	initColorChoicesCarousel,
	initLinklistCarousel,
	initMainMenuCarousel,
	initProductCarousel,
} from './source/Carousel';
import {initCartReminder} from './source/CartReminder';
import {runDeferredExecutes, safeRunFunc} from './source/DeferredExecute';
import {initSuggestHandler} from "./source/FactfinderSuggest";
import {initFormValidation} from "./source/Form";
import {initFormSalutation} from "./source/FormSalutation";
import {initFooterBadgesLazyLoad} from './source/LazyLoad';
import {initListpageViewSwitcher} from './source/ListpageViewSwitcher';
import {initMaps} from './source/Map';
import {initMenu, initFacetDesktop} from "./source/Menu";
import {initToggleNewsletterExpandableText} from './source/Newsletter';
import {initNotifications} from './source/Notification';
import {offcanvas_new, initBodyScrollLock} from './source/Offcanvas';
import {initPhotoSwipe} from './source/PhotoSwipe';
import {initPluscardApp, default as PluscardApp} from './source/PluscardApp';
import {initPopupBindings, notifyIfAvailable, outdatedBrowser} from "./source/Popup";
import {initPriceSlider} from './source/PriceSlider';
import {initReadmoreText, initReadmoreTabs} from "./source/Readmore";
import {initScrollLock} from "./source/ScrollLock";
import {initImageErrorHandler} from './source/ImageErrorHandler';
import {initScrollToTopListeners} from './source/ScrollToTop';
import {initDefaultSlider} from './source/Slider';
import {initSmartBreadcrumbs} from "./source/SmartBreadcrumbs";
import {initSliderSmartBullets} from './source/SmartBullets';
import {initStickyElements} from './source/StickyElement';
import {initTabbedContent} from './source/TabbedContent';
import {openInputLabelTooltip} from './source/Tooltip';
import {initConversionTracking} from './source/Tracking';
import {initTriggerController, initInputController} from './source/Trigger';
import {initDataLayerTracking} from './source/DataLayerTracking';
import {initDynamicYield} from "./source/DynamicYield";
import {initSizeHint} from './source/SizeHint.js';
import {initDynamicYieldEvents} from './source/DynamicYieldEvents';

/**
 * Expose Helpers to Global Scope.
 */
EN.Media = MediaHelper;
EN.Render = RenderHelper;
EN.Cookies = Cookies;

/**
 * Expose Modules to Global Scope.
 */
EN.ClassClick = ClassClick;
EN.ImageSwap = ImageSwap;
EN.PageInfo = PageInfo;
EN.PhotoSwipe = PhotoSwipe;
EN.PluscardApp = PluscardApp;

/**
 * Expose Functions to Global Scope.
 */
import * as customFunctions from './functions';
import {initFavoriteStoreSelect} from "./source/favoriteStoreSelect";
EN_KO.functions = Object.assign( {}, EN_KO.functions, customFunctions );

$( document ).ready( function() {

	/**
   * Setup Default Elements.
   */
	EN_KO.elements.$window = $( window );
	EN_KO.elements.$document = $( document );
	EN_KO.elements.$html = $( 'html' );
	EN_KO.elements.$body = $( 'body' );


	/**
   * ClassClick will (and should) replace TriggerController at one point.
   * But for now, just make it available.
   * For details about how to use it, read the docs inside the partial.
   */
	ClassClick.init( {
		classNames: {
			active: 'en_is_active',
			locked: 'en_is_locked',
		},
	} );

	// modules/PageInfo.js
	PageInfo.init();

	// Collect all Inits in Array to run them in order.
	const allInits = [

		// source/ListpageViewSwitcher.js
		() => initListpageViewSwitcher(),

		// source/Menu.js
		() => initMenu(),
		() => initFacetDesktop(),

		// source/FactfinderSuggest.js
		() => initSuggestHandler(),

		// source/PluscardApp.js
		() => initPluscardApp(),

		// source/Notification.js
		() => initNotifications(),

		// source/Accordion.js
		() => initAccordions(),

		// source/Carousel.js
		() => initMainMenuCarousel(),
		() => initProductCarousel(),
		() => initBrandCarousel(),
		() => initLinklistCarousel(),
		() => initContentCarousel(),
		() => initColorChoicesCarousel(),
		() => initAn150MomentsCarousel(),
		() => initAn150ShopcatCarousel(),

		// source/Slider.js
		() => initDefaultSlider(),

		// source/smartBreadcrumb.js
		() => initSmartBreadcrumbs(),

		// source/smartBullets.js
		() => initSliderSmartBullets(),

		// source/AddedToCart.js
		() => initAddedToCart(),

		// source/Form.js
		() => initFormValidation(),

		// source/FormSalutation.js
		() => initFormSalutation(),

		// source/Barcode.js
		() => initOpenBarcodeScanner(),

		// source/Map.js
		() => initMaps(),

		// source/Lazyload.js
		() => initFooterBadgesLazyLoad(),

		// source/Newsletter.js
		() => initToggleNewsletterExpandableText(),

		// source/CartReminder.js
		() => initCartReminder(),

		// source/StickyElements.js
		() => initStickyElements(),

		// source/ScrollToTop.js
		() => initScrollToTopListeners(),

		// source/ReadMore.js
		() => initReadmoreText(),
		() => initReadmoreTabs(),

		// source/Trigger.js
		() => initTriggerController(),
		() => initInputController(),

		// source/ScrollLock.js
		() => initScrollLock(),

		() => initDynamicYieldEvents(),
		() => initFavoriteStoreSelect(),

		() => {
			// init slider, bullets and carousels if quickview or popup opened or pdp reloaded
			$( document ).on( 'popup_open.en article_detail_reload.en load_productmain_quick_stock.acl', ( ev ) => {
				initDefaultSlider( ev.target );
				initSliderSmartBullets( ev.target );
				initColorChoicesCarousel( ev.target );
				initTriggerController( ev.target );
				initProductCarousel( ev.target );
			} );

			// init tabs read more on pdp reload
			$( document ).on( 'article_detail_reload.en', ( ev ) => {
				initReadmoreTabs( ev.target );
				initSizeHint( ev.target );
			} );

			// init slider of ff products if dom updated
			document.querySelector( '.mdl_factfinder_aftersearch' )?.addEventListener( 'update.ff', ev => {
				initDefaultSlider( ev.target.querySelector( '.en_mdl_products' ) );
				initSliderSmartBullets( ev.target.querySelector( '.en_mdl_products' ) );
			} );

			$( document ).on( 'load_article_detail_popup.acl', function( ev ) {
				initSliderSmartBullets( ev.target );
			} );
		},

		() => {
			// Lazyloaded scoped initialisation for CMS Contents.
			document.addEventListener( 'lazyload.tao', ( evt ) => {
				const scopeEl = evt.target || document;
				const lazyInits = [

					// source/Accordion.js
					() => initAccordions( scopeEl ),

					// source/Carousel.js
					() => initProductCarousel( scopeEl ),
					() => initBrandCarousel( scopeEl ),
					() => initLinklistCarousel( scopeEl ),
					() => initContentCarousel( scopeEl ),

					// source/Slider.js
					() => initDefaultSlider( scopeEl ),

					// source/smartBreadcrumb.js
					() => initSmartBreadcrumbs( scopeEl ),

					// source/smartBullets.js
					() => initSliderSmartBullets( scopeEl ),

					// source/Form.js
					() => initFormValidation( scopeEl ),

					// source/FormSalutation.js
					() => initFormSalutation( scopeEl ),

					// source/Trigger.js
					() => initInputController( scopeEl ),

					// source/TabbedContent.js
					() => initTabbedContent( scopeEl ),
				];

				// Run all inits in order.
				lazyInits.forEach( ( initFunction ) => safeRunFunc( initFunction ) );
			} );
		},

		() => {
			// modules/ImageSwap.js
			if ( EN.Media.matches( 'small' ) ) {
				new ImageSwap( {
					classNames: {
						active: 'en_is_active',
						selected: 'en_is_selected'
					}
				} );
			}
		},

		// source/DeferredExecutes.js
		() => runDeferredExecutes(),

		// source/Offcanvas.js
		() => offcanvas_new(),
		() => initBodyScrollLock(),


		// source/Popup.js
		() => initPopupBindings(),
		() => notifyIfAvailable(),
		() => outdatedBrowser(),

		// source/PriceSlider.js
		() => initPriceSlider(),

		// source/Tooltip.js
		() => openInputLabelTooltip(),

		// source/TabbedContent.js
		() => initTabbedContent(),

		// source/Tracking.js
		() => initConversionTracking(),

		// source/DataLayerTracking.js
		() => initDataLayerTracking(),

		// source/DynamicYield.js
		() => initDynamicYield()
	];

	// Run all inits in order.
	allInits.forEach( ( initFunction ) => safeRunFunc( initFunction ) );

} );

$( document ).ready( function(){
	initPhotoSwipe();

	initImageErrorHandler();
	document.addEventListener( 'simple_lazyload.sl', function( ev ) {
		initImageErrorHandler( ev.target );
	} );

} );
